// store/modules/auth.js
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    permissions: [],
    userInfo: null
  },
  getters: {
    getPermissions: (state) => state.permissions,
    getUserInfo: (state) => state.userInfo
  },
  mutations: {
    SET_PERMISSIONS(state, payload) {
      state.permissions = payload;
    },
    SET_USER_INFO(state, payload) {
      state.userInfo = payload;
    }
  },
  actions: {
    async fetchPermissions({ commit }) {
      try {
        const response = await Vue.prototype.$http2.get('/api/user/permissions');

        const { permissions, sites } = response.data.data;

        commit('SET_PERMISSIONS', permissions);

        commit('appStore/UPDATE_PERMISSIONS_MODULES', permissions, { root: true });

        const userInfo = Vue.$cookies.get('userInfo');
        if (userInfo) {
          if (sites) userInfo.userData.sites = sites;
          commit('SET_USER_INFO', userInfo);
        }

        return { permissions, sites };
      } catch (error) {
        console.error('Erro ao buscar permissões:', error);
        throw error;
      }
    }
  }
};
